import React, { PureComponent, Suspense } from "react";
import PropTypes from "prop-types";
import { BemHelper } from "utils/bemHelper";

import { selectionTypes } from "store/filters/selectionTypes";

import { Accordion } from "blocks/Accordion/Accordion";
import { SortOptions } from "components/SearchResults/SortOptions/SortOptions";

import "./Sidebar.scss";

const AccordionContent = React.lazy(() => import(/* webpackChunkName: "accordion" */ './AccordionContent')
  .then(module => ({ default: module.AccordionContent })));

const bem = new BemHelper("z-sidebar");

export class Sidebar extends PureComponent {

  static propTypes = {
    heading: PropTypes.string.isRequired,
    resetButtonText: PropTypes.string.isRequired,
    filters: PropTypes.array.isRequired,
    addFilter: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired,
    canSortResults: PropTypes.bool.isRequired,
  };

  state = {
    accordionStates: {},
  };

  filterComponentFactory = {
    [selectionTypes.single]: {
      buildLabel: (filter, accordionId) =>
        filter.selectionLabelFormat && !this.isOpen(accordionId)
          ? filter.selectionLabelFormat.replace("{value}", filter.valueFormat)
          : filter.label,
    },
    [selectionTypes.list]: {
      buildLabel: (filter, accordionId) => filter.label,
    },
    [selectionTypes.step]: {
      buildLabel: (filter, accordionId) =>
        filter.selectionLabelFormat && !this.isOpen(accordionId)
          ? filter.selectionLabelFormat.replace("{value}", filter.options[0].value)
          : filter.label,
    },
    [selectionTypes.input]: {
      buildLabel: (filter, accordionId) => filter.label,
    },
  };

  isOpen = accordionId => this.state.accordionStates[accordionId] || false;

  handleAccordionToggle(accordionId, status) {
    this.setState({
      accordionStates: {
        ...this.state.accordionStates,
        [accordionId]: status.isOpen,
      },
    });
  }

  renderSortOptions() {
    if(!this.props.canSortResults)
      return null;

    return (
      <div className={bem.for("sort", "sm-visible")}>
        <SortOptions {...this.props.sortOptions} onChange={this.props.updateSort} />
      </div>
    );
  }

  renderFilters() {
    return this.props.filters.map(filter => {
      const factory = this.filterComponentFactory[filter.selectionType];
      const accordionId = `accordion_${filter.key}`;
      return (
        <Accordion
          key={filter.label}
          label={factory.buildLabel(filter, accordionId)}
          id={accordionId}
          isOpen={this.isOpen(accordionId)}
          onToggle={status => this.handleAccordionToggle(accordionId, status)}>
            <Suspense fallback={""}>
                <AccordionContent
                  filter={filter}
                  resetButtonText={this.props.resetButtonText}
                  resetFilter={this.props.resetFilter}
                  addFilter={this.props.addFilter}
                  removeFilter={this.props.removeFilter}
                  updateFilter={this.props.updateFilter}
                />
            </Suspense>
        </Accordion>
      );
    });
  }

  render() {
    return (
      <section className={bem.component}>
        <header className={bem.for("heading", "md-visible")}>{this.props.heading}</header>
        <div className={bem.for("content")}>
          {this.renderSortOptions()}
          {this.renderFilters()}
        </div>
      </section>
    );
  }
}
